<template lang="pug">
.room-properties
  auto-table(:defines='$defines.property', unstackable, :compact='compact', :pagesize='pagesize', :data='room_properties', layout='room')
</template>

<script>
import { AutoTable } from '../auto'

export default {
  name: 'room-properties',
  components: { AutoTable },
  props: {
    properties: {
      type: Array,
      default() { return [] },
    },
    pagesize: {
      type: Number,
      default: 0,
    },
    compact: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    room_properties() {
      return this.$store.getters.properties_of_room(this.properties)
    },
  },
}
</script>



// WEBPACK FOOTER //
// RoomProperties.vue?14457c27